import React, { FC } from 'react';

import { Header, BillingsList } from './components';
import { Wrapper } from './styles';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const ClinicBilling: FC = () => {
  const { isExpiredSoon } = useSubscription();

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />
      <BillingsList />
    </Wrapper>
  );
};

export default ClinicBilling;
